import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getDetailCompanyOtherStatus = createAsyncThunk('/dashboard_detail_company_other_status/content', async (id) => {
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/detailCompanyOtherStatusDash/${id}`, {})
    return response.data;
})

export const dashboardDetailCompanyOtherStatusSlice = createSlice({
    name: 'dashboard_detail_company_other_status',
    initialState: {
        isLoading: false,
        dashboard_detail_company_other_status: []
    },

    /*extraReducers: {
        [getDetailCompanyOtherStatus.pending]: state => {
            state.isLoading = true
        },
        [getDetailCompanyOtherStatus.fulfilled]: (state, action) => {
            state.dashboard_detail_company_other_status = action.payload.data
            state.isLoading = false
        },
        [getDetailCompanyOtherStatus.rejected]: state => {
            state.isLoading = false
        },
    }*/
    extraReducers: (builder) => {
        builder
            .addCase(getDetailCompanyOtherStatus.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getDetailCompanyOtherStatus.fulfilled, (state, action) => {
                state.dashboard_detail_company_other_status = action.payload.data;
                state.isLoading = false;
            })
            .addCase(getDetailCompanyOtherStatus.rejected, (state) => {
                state.isLoading = false;
            });
    },  
})

export default dashboardDetailCompanyOtherStatusSlice.reducer